import { Locale as DateFnsLocale, parse, parseISO } from 'date-fns';
import { enUS, es, pt } from 'date-fns/locale';
import { formatInTimeZone } from 'date-fns-tz';
import React from 'react';

import { configuration } from '@/config';
import { LocaleContext } from '@/hooks/useTranslator';
import { Locale } from '@/types/locale';

// Create a context for timezone
export const TimezoneContext = React.createContext<string>(configuration.defaultTimezone);

interface DateFormatter {
  format(date: Date): string;
  parseAndFormat(value: string): string;
}

const toDateFnsLocale = (locale: Locale): DateFnsLocale => {
  switch (locale) {
    case 'en':
      return enUS;
    case 'es':
      return es;
    case 'pt':
      return pt;
  }
};

export const useDateFormatter = (
  outputFormatString: string,
  inputFormatString?: string,
): DateFormatter => {
  const locale = React.useContext(LocaleContext);
  const dateFnsLocale = toDateFnsLocale(locale);
  const timezone = React.useContext(TimezoneContext);

  return {
    format: (date: Date): string =>
      formatInTimeZone(date, timezone, outputFormatString, { locale: dateFnsLocale }),
    parseAndFormat: (value: string): string => {
      try {
        const date = inputFormatString
          ? parse(value, inputFormatString, new Date())
          : parseISO(value);
        return formatInTimeZone(date, timezone, outputFormatString, { locale: dateFnsLocale });
      } catch (error) {
        console.warn(error);
        return value;
      }
    },
  };
};
